import React from 'react';

const products = [
  {
    id: 1,
    name: 'Long Định Bến Tre',
    description: 'Gạo chất lượng cao',
    image: '/images/rice.jpg'
  },
  {
    id: 2,
    name: 'Siêu',
    description: 'Gạo thơm ngon',
    image: '/images/rice.jpg'
  },
  {
    id: 3,
    name: 'Quảng',
    description: 'Gạo đặc biệt',
    image: '/images/rice.jpg'
  },
  {
    id: 4,
    name: 'Gạo Tròn',
    description: 'Gạo chất lượng',
    image: '/images/rice.jpg'
  },
  {
    id: 5,
    name: 'Q5',
    description: 'Gạo thượng hạng',
    image: '/images/rice.jpg'
  },
  {
    id: 6,
    name: 'Hàm Châu',
    description: 'Gạo đặc sản',
    image: '/images/rice.jpg'
  },
  {
    id: 7,
    name: 'Khang Dân',
    description: 'Gạo chất lượng cao',
    image: '/images/rice.jpg'
  },
  {
    id: 8,
    name: 'Gạo 504',
    description: 'Gạo thơm ngon',
    image: '/images/rice.jpg'
  },
  {
    id: 9,
    name: 'Gạo Ấn',
    description: 'Gạo đặc biệt',
    image: '/images/rice.jpg'
  },
  {
    id: 10,
    name: 'Tấm Ấn',
    description: 'Tấm chất lượng cao',
    image: '/images/rice.jpg'
  },
  {
    id: 11,
    name: 'Tròn 202',
    description: 'Gạo thượng hạng',
    image: '/images/rice.jpg'
  }
];

function Products() {
  return (
    <div className="products-container">
      <h2 className="products-title">Sản Phẩm Của Chúng Tôi</h2>
      <div className="products-grid">
        {products.map(product => (
          <div key={product.id} className="product-card">
            <img src={product.image} alt={product.name} className="product-image" />
            <h3 className="product-title">{product.name}</h3>
            <p className="product-description">{product.description}</p>
            <button className="btn">Liên Hệ</button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Products; 